__turbopack_context__.v({
  "CommunityGrid": "CommunityGrid-module-sass-module__JK53ra__CommunityGrid",
  "Cont": "CommunityGrid-module-sass-module__JK53ra__Cont",
  "Stories": "CommunityGrid-module-sass-module__JK53ra__Stories",
});
